import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"
import PubSub from "pubsub-js"
import parse from "html-react-parser"

const AffiliateHero = () => {
  return (
    <div className="w-full pt-6 md:pt-10 xl:pt-7 2xl:pt-[78px] px-4 md:px-px1_l xl:px-px1_xl">
      <CMSRender
        contentType="PageSection"
        match={{ "content.name": "AffiliateHero" }}
        renderItem={(data, id) => {
          const { title, title_mobile, description, menu, images } = data;
          return (
            <div
              key={id}
              className="relative w-full max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-w2_xl 2xl:max-w-w1_xl flex items-center justify-between gap-2 xl:gap-14 mx-auto"
            >
              {/* Text Section */}
              <div className="relative w-full lg:w-[65%] xl:w-[900px] 2xl:w-[1080px] max-w-[500px] md:max-w-[800px] xl:max-w-full text-left z-10">
                <div>
                  <Typography
                    component="h1"
                    variant="title2"
                    className="hidden lg:block lg:w-full mb-6"
                  >
                    {title}
                  </Typography>

                  <Typography variant="h1" className="block lg:hidden mb-6">
                    {parse(title_mobile)}
                  </Typography>
                </div>

                <Typography variant="body_24" className="xl:w-[650px] 2xl:w-[735px] text-text mt-0 mb-10">
                  {description}
                </Typography>

                <Button
                  variant="primary_xl"
                  className="!text-[24px] lg:!text-[28px] xl:!text-[33px]"
                  onClick={() => PubSub.publish("open-contacts-partners")}
                >
                  {menu?.[0].label}
                </Button>
              </div>

              {/* Image Section */}
              <div className="absolute top-0 lg:top-10 2xl:top-0 right-0 md:right-[100px] lg:right-0 h-auto lg:h-full w-[38%] md:w-[45%] lg:w-[35%] xl:w-[40%] 2xl:w-[680px] md:max-w-[260px] lg:max-w-[450px] xl:max-w-[687px] 2xl:max-w-full flex items-start justify-end">
                <img
                  src={url(images?.[0])}
                  alt="Affiliate Icon"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

//The Aldoo Site Component definition
export const AldooComponent = {
  //the id that will be displayed in the admin
  id: "AffiliateHero",
  //the component used to run the logic
  component: AffiliateHero,
  //here we'll place the incoming data from the CMS
  input: {
  },
  // Component metadata for admin interface
  meta: {
    name: "Affiliate Hero",
    description: "Affiliate hero section",
    category: "Marketing",
  },
}

export default AffiliateHero
